import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { samplecollectModal } from '../Model/otherModule.model';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { AuthService } from 'app/auth/auth.service';
import { OtherMoudleService } from '../othermodule.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-sample-collected',
  templateUrl: './sample-collected.component.html',
  styleUrls: ['./sample-collected.component.scss']
})
export class SampleCollectedComponent implements OnInit {
  destroytestSamplelist$: Subject<boolean> = new Subject<boolean>();
  samplecollectionModel: samplecollectModal = {}
  private filteredLabBranchArray: Observable<any[]>;
  private filteredclinicalArray: Observable<any[]>;
  private labSampleCollectionDetailArray: any = [];
  collectedSamples: any = []
  postLabSampleCollectionarry = [];
  private labCollectionArray: any = [];
  searchParaValue: string = '';
  filteredLabCollectionArray: any[] = [];
  selectedlabIndex: number | null = null;
  labDate: any
  barcodeValues: string[] = [];
  searchType: string = 'patientID';
  isWithAcceptance: boolean = false;
  PendingForSampleCollection: boolean = true;
  private clinicalArray: any[] = [];

  selectedpK_BIllID: any;
  ptypecheck: any;
  datacheck: any
  sampleCollectionDetailByBillIdArray: any = [];
  branchControl: FormControl;
  autoclinicalControl: FormControl;
  constructor(private authService: AuthService,
    private otherService: OtherMoudleService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.autoclinicalControl = new FormControl();
    this.initializeLabBranchControl();
    this.labResultClinical("LABSAMPLECOLLECTIONDEPARTMENT");
    this.labDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.samplecollectionModel.branchName = this.authService.Loggeduser.branchname;
    this.samplecollectionModel.BranchId = this.authService.Loggeduser.branchid;
  }

  onBranchLabSelected(event) {
    this.samplecollectionModel.branchName = event.value;
    this.samplecollectionModel.BranchId = event.id;
    this.labSampleCollectionDetail();
  }
  clearLabBranchName(lbid) {
    if (!lbid) {
      this.samplecollectionModel.BranchId = null;
    }
  }

  initializeLabBranchControl() {
    this.branchControl = new FormControl();
    this.filteredLabBranchArray = this.branchControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterLabBranchFunction(branch)
          : this.authService.Branches.slice()
      )
    );
  }

  filterLabBranchFunction(name: string): any[] {
    return this.authService.Branches.filter((branch) =>
      branch.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }


  labResultClinical(type) {
    this.otherService.labResultClinicalDept(type).pipe(takeUntil(this.destroytestSamplelist$)).subscribe((res) => {
      this.clinicalArray = res;
      this.initializeLabclinicalControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  clearLabclinical(cid) {
    if (!cid) {
      this.samplecollectionModel.clinicalId = null;
    }
  }

  onDateChange() {
    this.labSampleCollectionDetail();
  }

  initializeLabclinicalControl() {
    this.autoclinicalControl = new FormControl();

    if (this.clinicalArray && this.clinicalArray.length > 0) {
      const firstClinic = this.clinicalArray[0];

      this.samplecollectionModel.clinicalName = firstClinic.name;
      this.samplecollectionModel.clinicalId = firstClinic.pK_Id;

      this.autoclinicalControl.setValue(firstClinic.name);
      this.labSampleCollectionDetail();
    }

    this.filteredclinicalArray = this.autoclinicalControl.valueChanges.pipe(
      startWith(""),
      map((cname) =>
        cname ? this.filterLabclinicalFunction(cname) : this.clinicalArray.slice()
      )
    );
  }


  filterLabclinicalFunction(cname: string): any[] {
    return this.clinicalArray.filter((clinic) =>
      clinic.name.toLowerCase().includes(cname.toLowerCase())
    );
  }
  onclinicalLabSelected(event) {
    this.samplecollectionModel.clinicalName = event.value;
    this.samplecollectionModel.clinicalId = event.id;
    this.labSampleCollectionDetail();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    this.PendingForSampleCollection = event.checked;
    this.labSampleCollectionDetail();
  }



  // to print barcode.....
  sinId(event: any, sinNo: string) {
    const isChecked = event.checked;
    const index = this.barcodeValues.indexOf(sinNo);
    if (isChecked) {
      if (index === -1) {
        this.barcodeValues.push(sinNo);
      }
    } else {
      if (index > -1) {
        this.barcodeValues.splice(index, 1);
      }
    }
  }

  printBarcode() {
    const hiddenDiv = document.getElementById('hiddenPrintArea');
    hiddenDiv!.style.display = 'block';

    setTimeout(() => {
      const printContent = hiddenDiv?.innerHTML;
      const printWidth = 1000;
      const printHeight = 800;

      const left = (screen.width / 2) - (printWidth / 2);
      const top = (screen.height / 2) - (printHeight / 2);

      const printWindow = window.open(
        '',
        '',
        `width=${printWidth},height=${printHeight},top=${top},left=${left},toolbar=0,scrollbars=0,status=0`
      );

      if (printWindow && printContent) {
        printWindow.document.write(`
        <html>
        <head>
          <title>Print Barcode</title>
          <style>
            body { text-align: center; padding-top: 50px; font-family: sans-serif; }
            svg { width: 500px; height: 150px; }
          </style>
        </head>
        <body onload="window.print();">
          ${printContent}
        </body>
        </html>
      `);
        printWindow.document.close();
      }

      hiddenDiv!.style.display = 'none';
    }, 100);
  }


  // First Wali Api .....
  lenghtcheck: any;
  labSampleCollectionDetail() {
    let payload = {
      "HeadName": "SAMPLE COLLECTION",
      "Fromdate": moment(this.labDate).format('YYYY-MM-DD'),
      "Todate": moment(this.labDate).format('YYYY-MM-DD'),
      "BranchID": this.samplecollectionModel.BranchId,
      "PendingForSampleCollection": this.PendingForSampleCollection,
      "DeptId": this.samplecollectionModel.clinicalId
    }
    this.otherService.LabSampleCollection(payload).pipe(takeUntil(this.destroytestSamplelist$)).subscribe((labres: any) => {
      this.labCollectionArray = labres;
      this.lenghtcheck = this.labCollectionArray.length;
      this.filteredLabCollectionArray = labres;
      this.selectedlabIndex = null;
      this.sampleCollectionDetailByBillIdArray = null;
      this.barcodeValues = [];
      this.isWithAcceptance = false;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }


  filterLabData() {
    if (!this.searchParaValue || !this.searchType) {
      this.filteredLabCollectionArray = this.labCollectionArray;
      return;
    }

    const searchValue = this.searchParaValue.toString().toLowerCase();

    this.filteredLabCollectionArray = this.labCollectionArray.filter(item => {
      const itemValue = item[this.searchType];
      return itemValue && itemValue.toString().toLowerCase().includes(searchValue);
    });
  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }


  //middle wali Api.....
  storeselectData: any;
  labSampleCollectionDetailByBillId(item: any, index: number) {
    this.storeselectData = item;
    this.selectedpK_BIllID = item.pK_BIllID;
    this.selectedlabIndex = index;
    this.datacheck = moment(item.billDate).format('YYYY-MM-DD');
    let Payload = {
      "BillID": this.selectedpK_BIllID,
      "HeadName": "SAMPLE COLLECTION",
      "PType": item.pType,
      "DeptId": this.samplecollectionModel.clinicalId,
      "BillDate": moment(item.billDate).format('YYYY-MM-DD'),

    }
    this.otherService.GetLabSampleCollectionDetailByBillId(Payload).pipe(takeUntil(this.destroytestSamplelist$)).subscribe((res) => {
      this.sampleCollectionDetailByBillIdArray = res;
      this.cdr.detectChanges();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  get headName(): string {
    return this.isWithAcceptance
      ? "UPDATESAMPLECOLLECTIONSTATUSCOLLECTEDWITHACCEPTANCE"
      : "UPDATESAMPLECOLLECTIONSTATUSCOLLECTED";
  }

  changeheadName() {
    this.collectedSamples.forEach(item => {
      item.HeadName = this.headName;
    });
  }

  onCollectedChange(item: any) {
    if (item.isCollected) {
      const existing = this.collectedSamples.find((x: any) => x.FK_BillDetailID === item.pK_BillDetailId);
      if (!existing) {
        this.collectedSamples.push(JSON.parse(JSON.stringify({
          HeadName: this.headName,
          PType: item.pType,
          SINID: item.sinid ?? null,
          PK_TranID: item.pK_TranID ?? 0,
          PK_BillID: item.pK_BIllID,
          BillDate: this.datacheck,
          IsEdit: !!item.pK_TranID,
          FK_BillDetailID: item.pK_BillDetailId,
          SampleQty: item.sampleQty,
          SampleRemarks: item.sampleRemarks,
          VialQty: item.vialQty,
          LabDeptCode: item.labDeptCode,
          AcceptStatus: item.acceptStatus,
          AcceptRemarks: item.acceptRemarks,
          TestApprovalStatus: item.testApprovalStatus
        })));
      }
    } else {
      const cdata = this.collectedSamples.filter((x: any) => x.FK_BillDetailID !== item.pK_BillDetailId);
       this.collectedSamples =JSON.parse(JSON.stringify(cdata));
    }
  }


  // 3rd wali Api ......
  InsertUpdateSampleStatus() {
    let payload = {
      InsertLabSampleCollectionDetail: this.collectedSamples
    }

    this.otherService.InsertUpdateSampleStatus(payload).pipe(takeUntil(this.destroytestSamplelist$)).subscribe((inres: any) => {
      if (inres && inres.statusCode === "1") {
        this.labSampleCollectionDetailByBillId(this.storeselectData, this.selectedlabIndex)
        this.labSampleCollectionDetail();
        this.dashboardService.openSnackBar("Sample Collected Sucessfully", "OK");
        this.collectedSamples = [];
        // this.sampleCollectionDetailByBillIdArray = [];
        // this.storeselectData= [];
      }

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  ngOnDestroy() {
    this.destroytestSamplelist$.next(true);
    this.destroytestSamplelist$.unsubscribe();
    this.filteredLabBranchArray = null;
    this.filteredclinicalArray = null;
    this.sampleCollectionDetailByBillIdArray = null;
    this.filteredLabCollectionArray = null;
    this.labCollectionArray = null;
    this.selectedlabIndex = null;
    this.isWithAcceptance = null;
    this.collectedSamples = null;
  }
}
